import React from 'react';

interface ProgressItemProps {
    imgLink: string;
    name: string;
    value: string;
}

export const ProgressItem: React.FC<ProgressItemProps> = ({
    imgLink,
    name,
    value,
}) => {
    return (
        <div className='col-12 col-sm-12 col-xs-12 col-md-4 col-lg-4 col-xl-4 col-fill'>
            <div className='card thesisOverview-progress-card'>
                <img src={`${imgLink}`} alt='thesis-overview' />

                <div className='thesisOverview-progress-card-content'>
                    <span> {name} </span>
                    <p> {value} </p>
                </div>
            </div>
        </div>
    );
};
